module.exports = __webpack_public_path__ + "static/media/great dunmow.967b19ac.jpg";